import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursAbcTestimonials() {
  const testimonials = [{
    quote: 'Am participat la cursurile de Theta Healing® susținute de Adrian Huniade cu deschidere totală, iar experiența a depășit orice așteptare. Trainerul a fost extrem de empatic și bine pregătit, iar atmosfera caldă m-a făcut să mă simt în siguranță. Ceea ce mi-a plăcut cel mai mult a fost caracterul practic — am aplicat tehnicile în timp real și am observat rezultate rapide: claritate mentală, liniște interioară și încredere în mine. Recomand cu toată inima oricui își dorește o transformare autentică și profundă.',
    author: 'Carmen Crișan',
    location: 'Cursantă',
    initial: 'C'
  }, {
    quote: 'Înainte de aceste cursuri eram pierdută, fără direcție, fără claritate. Cursurile de Theta Healing® cu maestrul Adrian Huniade au fost exact acel punct de cotitură. Cu blândețe și răbdare, a creat un spațiu în care m-am simțit în siguranță să mă deschid și să lucrez profund cu mine. Pas cu pas m-am stabilizat emoțional, am înțeles tiparele și am învățat să le schimb. Transformările s-au reflectat rapid în realitate: o casă, o afacere și conexiuni autentice cu cei dragi.',
    author: 'Feli Iscru',
    location: 'Cursantă',
    initial: 'F'
  }, {
    quote: 'L-am descoperit pe Adrian acum aproximativ 6 ani, într-o perioadă în care eram derutat și nu aveam un drum clar în viață. În urma cursurilor lui, am început treptat să văd mai limpede pașii pe care trebuie să îi urmez. Mi-a reaprins scânteia interioară și m-a ajutat să capăt claritate și direcție.',
    author: 'Coras Nicolae Dumitru',
    location: 'Săud, jud. Bihor',
    initial: 'C'
  }, {
    quote: 'Am participat la cursurile lui Adrian cu dorința de a lucra mai profund cu mine însămi. Experiența a fost peste așteptările mele — am învățat tehnici practice de identificare și schimbare a convingerilor limitative. Instructorul a fost calm, empatic și foarte clar, iar schimbările s-au observat chiar în timpul cursului.',
    author: 'Emilia Popșor',
    location: 'Medic pediatru, Calgary, Canada',
    initial: 'E'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-965">
      <div className="max-w-7xl mx-auto px-6" data-id="element-966">
        <SectionHeading title="Ce spun oamenii care au participat la cursurile lui Adrian" data-id="element-967" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-968">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index % 2 * 0.2
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-brand-text/5 flex flex-col h-full relative" data-id="element-969">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-brand-gold/10" data-id="element-970" />

              <div className="flex-grow mb-8 relative z-10 flex flex-col" data-id="element-971">
                <p className="font-subtitle italic text-xl text-brand-text/80 leading-relaxed flex-grow" data-id="element-972">
                  "{t.quote}"
                </p>
              </div>

              <div className="flex items-center gap-4 mt-auto" data-id="element-973">
                <div className="w-12 h-12 rounded-full bg-brand-purple text-white flex items-center justify-center font-heading font-bold text-xl shrink-0" data-id="element-974">
                  {t.initial}
                </div>
                <div data-id="element-975">
                  <h4 className="font-bold text-brand-text" data-id="element-976">{t.author}</h4>
                  <p className="text-sm text-brand-textSec" data-id="element-977">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-978">
          <CTAButton data-id="element-979" />
        </motion.div>
      </div>
    </section>;
}